// Optimistic-update primitive for TanStack Query.
//
//   const rollback = await optimistic(qc, { queryKey }, (data) => next)
//   try { await request() } catch { rollback() }
//
// It cancels in-flight fetches for the matched queries (so a slow refetch
// cannot overwrite the optimistic value), snapshots them, applies the updater
// and returns a function that restores the snapshot exactly.

export async function optimistic(queryClient, filters, updater) {
  await queryClient.cancelQueries(filters)
  const snapshot = queryClient.getQueriesData(filters)
  for (const [key, data] of snapshot) {
    if (data !== undefined) queryClient.setQueryData(key, updater(data, key))
  }
  return () => {
    for (const [key, data] of snapshot) queryClient.setQueryData(key, data)
  }
}

export function combine(...rollbacks) {
  return () => {
    for (const rollback of [...rollbacks].reverse()) rollback?.()
  }
}
